import { Bird, Cat, Dog, PawPrint, Rabbit, type LucideIcon } from 'lucide-react';

const ANIMALS: LucideIcon[] = [Cat, Dog, Rabbit, Bird, PawPrint];

function animalFor(value: string) {
  const index = [...value].reduce((sum, character) => sum + character.charCodeAt(0), 0) % ANIMALS.length;
  return ANIMALS[index];
}

export function UserAnimalAvatar({
  seed,
  className = '',
  iconClassName = '',
}: {
  seed: string;
  className?: string;
  iconClassName?: string;
}) {
  const Animal = animalFor(seed || 'atlas-user');
  return (
    <span className={`grid shrink-0 place-items-center bg-atlas-subtle text-atlas-ink ${className}`} aria-hidden="true">
      <Animal className={`stroke-[1.25] ${iconClassName}`} />
    </span>
  );
}
